<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <b-modal
      v-model="isOpen"
      has-modal-card
      trap-focus
      scroll="keep"
      aria-role="dialog"
      aria-label="GRAEModale"
      :aria-modal="true"
      class="GRAEModale"
      @cancel="emitCloseModale(false)"
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <H3TitleView class="modal-card-title"
            >{{ $t("usersList.grae-modale-title").toString() }}
          </H3TitleView>
          <button
            type="button"
            class="delete"
            aria-label="close"
            @click="emitCloseModale(false)"
          ></button>
        </header>

        <section class="modal-card-body">
          <GroupCheckboxesWithValidation
            v-if="graeListIds.length !== 0 && !isLoading"
            v-model="selectedGraesIds"
            vid="graeModale"
            rules="required|maxChoices:3"
            :label="$t(`usersList.grae-modale-chose-grae`)"
            :data="graeListIds"
            :check-box-labels="graeListRegions"
            :vertical-display="true"
            class="GRAEModale-checkboxes"
          />
        </section>

        <footer class="modal-card-foot">
          <div class="buttons">
            <div class="hoverable-discrete-link mr-3" @click="emitCloseModale(false)">
              {{ $t("close-generic") }}
            </div>
            <b-button rounded type="is-primary" @click="handleSubmit(saveAndClose)">
              {{ $t("save-generic") }}
            </b-button>
          </div>
        </footer>
      </div>
    </b-modal>
  </ValidationObserver>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import { UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { OrganismeService } from "@/services/rest/organisme/OrganismeService"
import GroupCheckboxesWithValidation from "@/views/inputs/GroupCheckBoxesWithValidation.vue"
import { UsersService } from "@/services/rest/users/UsersService"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import { BButton, BModal } from "buefy"

export default defineComponent({
  name: "GRAEModale",
  components: {
    H3TitleView,
    ValidationObserver,
    GroupCheckboxesWithValidation,
    BButton,
    BModal,
  },
  props: {
    open: { type: Boolean, default: false },
    user: { type: Object as PropType<UtilisateurDTO>, default: () => new UtilisateurDTO() },
  },

  emits: ["close-modale"],
  data() {
    return {
      organismeService: OrganismeService.INSTANCE,
      usersService: UsersService.INSTANCE,
      infoReportingService: InfoReportingService.INSTANCE,
      graeListIds: [] as Array<string>,
      graeListRegions: [] as Array<string>,
      isLoading: false,
      selectedGraesIds: [] as string[],
    }
  },
  computed: {
    isOpen: {
      get(): boolean {
        return this.open
      },
      set(value: boolean): void {
        if (!value) {
          this.emitCloseModale(false)
        }
      },
    },
  },
  watch: {
    open(): void {
      if (this.open) {
        this.updateSelectedGraes()
      }
    },
  },
  created(): void {
    this.init()
  },
  methods: {
    async init(): Promise<void> {
      this.isLoading = true
      try {
        const graeList = await this.organismeService.getAllGraes()
        this.graeListIds = graeList.map((g) => g.id)
        this.graeListRegions = graeList.map((g) => g.region)
        this.updateSelectedGraes()
      } catch (e: any) {
        // Silent catch
      }
      this.isLoading = false
    },
    updateSelectedGraes(): void {
      this.selectedGraesIds = []
      if (this.user.grae) {
        this.selectedGraesIds.push(this.user.grae.id)
      }
      if (this.user.instructedGraes && this.user.instructedGraes.length !== 0) {
        this.selectedGraesIds.push(...this.user.instructedGraes)
      }
    },
    async saveAndClose(): Promise<void> {
      // let newUser = this.user
      let refresh = false
      try {
        if (!this.user.id) {
          return
        }
        // newUser = await this.usersService.affectGraes(this.user.id, this.selectedGraesIds)
        await this.usersService.affectGraes(this.user.id, this.selectedGraesIds)
        refresh = true
        this.infoReportingService.success(this.$t("usersList.grae-modale-success").toString())
      } catch (e: any) {
        this.infoReportingService.error(
          this.$t("usersList.grae-modale-error").toString(),
          e as Error,
        )
      }

      this.emitCloseModale(refresh)
    },
    emitCloseModale(refresh: boolean): void {
      this.$emit("close-modale", refresh)
    },
  },
})
</script>

<style lang="scss">
.title-without-margin {
  .title-view {
    margin-top: 0;
  }
}

.GRAEModale {
  &.modal .modal-card {
    height: 75%;
    overflow-y: auto !important;
  }

  .animation-content {
    height: 100%;
  }
}
</style>
